import { AdministrativeArea, Country } from "../../common/redux/countryActions";
import { Profession } from "../../common/redux/professionAction";
import { DisponibiliteProfessionnel } from "../../search/model/Disponibilite";
import { UserStructureResponse } from "../../structures/model/StructureModel";

export interface UserProfessionnelResponse {
    administrativeAreas: AdministrativeArea[];
    country: Country;
    nom: string;
    prenom: string;
    profession: Profession[];
    disponibilities: DisponibiliteProfessionnel[];
    id: string;
    email: string;
    roles: string[];
    enabled: boolean;
    profile_image: string;
    profileImage: AvatarResponse;
    description: string;
    telephone: string;
    changeRequested?: boolean;
}

export interface CreateDisponibiliteProfessionnel {
    country: string;
    administrativeAreas: string[];
    profession: string[];
    selection: string[];
    description: string;
    type: string;
    dateDemarrage: string | null;
    dateFin?: string | null;
    heureDemarrage: string | null;
    heureFin: string | null;
}

export interface StructureInterestedByProfessionnel {
    Structure: UserStructureResponse;
    status: string;
}

export const emptyUserProfessionnel: UserProfessionnelResponse = {
    nom: "",
    prenom: "",
    profession: [],
    disponibilities: [],
    id: "",
    email: "",
    roles: [],
    profile_image: "",
    enabled: false,
    telephone: "",
    profileImage: {
        id: "",
        contentUrl: "",
    },
    description: "",
    administrativeAreas: [],
    country: {
        id: 0,
        name: "",
        code: "",
        administrativeAreaName: "",
    },
};

export interface AvatarResponse {
    id: string;
    contentUrl: string;
}
